import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router'; 

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers
import { PageContentContainerComponent } from './components/page-content-container.component';

// Services metier

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		RouterModule,
	],
	providers: [
	],
	declarations: [
		PageContentContainerComponent,
	],
	exports: [
	]
})
export class PageStructureModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('pageContentContainer',
		downgradeComponent({ component: PageContentContainerComponent })
	) //
;